// extracted by mini-css-extract-plugin
export default {"dropdown":"Screens_dropdown__4BWtH"};